<div class="outage-banner" *ngIf="visible">
  <div class="banner-content">

    <div class="warning-icon">
      ⚠
    </div>

    <div class="banner-message">      
      {{message}}
    </div>

    <button class="close-btn" aria-label="Close Banner" (click)="closeBanner()">
      ✕
    </button>

  </div>
</div>